import { client, fileDownloadClient } from "../../services/axiosClient";

const BASE = "api/feedback";

export const feedbackApi = {
  listTopics: () => client.get(`${BASE}/topics/`),

  getTopic: (id) => client.get(`${BASE}/topics/${id}/`),

  createTopic: (contentHtml) =>
    client.post(`${BASE}/topics/`, { content_html: contentHtml }),

  updateTopic: (id, data) => client.patch(`${BASE}/topics/${id}/`, data),

  deleteTopic: (id) => client.delete(`${BASE}/topics/${id}/`),

  createComment: (topicId, contentHtml) =>
    client.post(`${BASE}/topics/${topicId}/comments/`, {
      content_html: contentHtml,
    }),

  updateComment: (topicId, commentId, contentHtml) =>
    client.patch(`${BASE}/topics/${topicId}/comments/${commentId}/`, {
      content_html: contentHtml,
    }),

  deleteComment: (topicId, commentId) =>
    client.delete(`${BASE}/topics/${topicId}/comments/${commentId}/`),

  uploadAttachment: (topicId, commentId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return client.post(
      `${BASE}/topics/${topicId}/comments/${commentId}/attachments/`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  downloadAttachment: (attachmentId) =>
    fileDownloadClient.get(`${BASE}/attachments/${attachmentId}/download/`),

  generateTitle: (contentHtml) =>
    client.post(`${BASE}/generate-title/`, { content_html: contentHtml }),
};
